import produce from 'immer';
import { GetNewLTV } from '../common/HealthFactor';
import { calculateLTV, getAssociatedAsset, mapToDebtAsset } from '../../util/ltv';

export const getNewLTV: GetNewLTV = ({ currentLTV: { args }, normalizedTokenAmount, selectedAsset }) => {
  const newArgs = produce(args, (draft) => {
    const associatedAsset = getAssociatedAsset(draft.debtAssets, selectedAsset);

    if (associatedAsset) {
      associatedAsset.balance += normalizedTokenAmount.toBigInt();
    } else {
      const newDebtAsset = mapToDebtAsset(selectedAsset);

      newDebtAsset.balance = normalizedTokenAmount.toBigInt();

      draft.debtAssets.push(newDebtAsset);
    }
  });

  return calculateLTV(newArgs);
};
